import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { onCLS, onFID, onLCP, onTTFB, onINP } from 'web-vitals';

/**
 * Application Insights initialization (per spec §8 + companion §4.1).
 * Connection string z env: VITE_APPINSIGHTS_CONNECTION_STRING.
 *
 * Graceful degradation: jeśli connection string undefined (np. tests / dev bez AI), init no-op.
 */

export const reactPlugin = new ReactPlugin();

let appInsightsInstance: ApplicationInsights | null = null;

export function initAppInsights(): ApplicationInsights | null {
  const connectionString = import.meta.env['VITE_APPINSIGHTS_CONNECTION_STRING'];

  if (typeof connectionString !== 'string' || connectionString.length === 0) {
    if (import.meta.env.DEV) {
      console.info('[AppInsights] connection string not configured — telemetry disabled');
    }
    return null;
  }

  const ai = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: {},
      },
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: false,
      enableResponseHeaderTracking: false,
      // Trace ID propagation: AI doda automatycznie correlation header, APIM przekaże dalej.
    },
  });

  ai.loadAppInsights();
  ai.trackPageView();

  // Web Vitals → custom events.
  onCLS((m) => ai.trackMetric({ name: 'web.vitals.cls', average: m.value }));
  onFID((m) => ai.trackMetric({ name: 'web.vitals.fid', average: m.value }));
  onLCP((m) => ai.trackMetric({ name: 'web.vitals.lcp', average: m.value }));
  onTTFB((m) => ai.trackMetric({ name: 'web.vitals.ttfb', average: m.value }));
  onINP((m) => ai.trackMetric({ name: 'web.vitals.inp', average: m.value }));

  appInsightsInstance = ai;
  return ai;
}

export function getAppInsights(): ApplicationInsights | null {
  return appInsightsInstance;
}
